import { getTheme } from 'mol-ui';
import styled from 'styled-components';

export const Container = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
`;

export const Image = styled.img`
    height: 100%;
    object-fit: contain;
    width: 100%;
`;

export const ImageContainer = styled.div`
    height: 400px;
    margin-bottom: 20px;
    max-width: 100%;
`;
